export default __webpack_public_path__ + "static/media/mode-1.b7533129.svg";